import {
  getAccount,
  changePassword,
  confirm,
  requestConfirmationEmail,
  login,
  logout,
  register,
  requestPasswordReset,
  resetPassword,
  update,
  addAddress,
  updateAddress,
  removeAddress,
  setDefaultBillingAddress,
  setDefaultShippingAddress,
} from '../../actions/account';
import { createSession, addPayment } from '../../actions/adyen';
import {
  cartItems,
  addItem,
  checkout,
  ctCheckout,
  getThankYouOrder,
  generateOrderNumber,
  generateAnonymousToken,
  orderHistory,
  removeItem,
  getShippingMethods,
  getOrderShippingMethod,
  setShippingMethod,
  updateCart,
  updateItem,
  redeemDiscountCode,
  getCartDiscount,
  removeDiscountCode,
  getProjectSettings,
} from '../../actions/cart';
import { getWishlist, addToWishlist, removeLineItem, updateLineItem } from '../../actions/wishlist';
import { UseAccount } from './UseAccount';
import { UseAdyen } from './UseAdyen';
import { UseCart } from './UseCart';
import { UseWishlist } from './UseWishlist';

export interface FrontasticState {
  useCart: UseCart;
  useAccount: UseAccount;
  useWishlist: UseWishlist;
  useAdyen: UseAdyen;
}

export const getFrontasticState = (): FrontasticState => {
  return {
    useCart: {
      ...cartItems(),
      addItem,
      updateCart,
      removeItem,
      updateItem,
      getShippingMethods,
      getOrderShippingMethod,
      setShippingMethod,
      checkout,
      ctCheckout,
      getThankYouOrder,
      generateOrderNumber,
      generateAnonymousToken,
      orderHistory,
      getProjectSettings,
      redeemDiscountCode,
      removeDiscountCode,
      getCartDiscount,
    },
    useAccount: {
      ...getAccount(),
      login,
      logout,
      register,
      confirm,
      requestConfirmationEmail,
      changePassword,
      requestPasswordReset,
      resetPassword,
      update,
      addAddress,
      updateAddress,
      removeAddress,
      setDefaultBillingAddress,
      setDefaultShippingAddress,
    },
    useWishlist: {
      ...getWishlist(),
      addToWishlist,
      removeLineItem,
      updateLineItem,
    },
    useAdyen: {
      createSession,
      addPayment,
    },
  };
};
